'use strict';

var $ = require('jquery');
var minicart = require('../../components/header/minicart');
var cartoverlay = require('../../components/checkout/cartoverlay');
var page = require('../../components/page');
var util = require('../../utils/util');
var progress = require('../../utils/progress');
var variationValidation = require('./validVariation.js');
var dytracking = require('../../components/tracking/dytracking');
var gtmTracking = require('../../components/tracking/tracking');
var optiTracking = require('../../components/tracking/optimizely');
var fitPredictor = require('../../components/fit-predictor');
const optiExperiment = require('../../components/optimizelyExperimentation');

/**
 * @description Make the AJAX request to add an item to cart
 * @param {Element} form The form element that contains the item quantity and ID data
 * @returns {Promise}
 */
var addItemToCart = function (form, setId) {
    var $form = $(form);
    var $qty = $form.find('select[name="Quantity"]');
    var selectedQty = '1';
    var url = util.ajaxUrl(Urls.addProduct);

    if (!$qty.length || isNaN($qty.val()) || parseInt($qty.val(), 10) === 0) {
        $qty.val(selectedQty);
    }

    if (setId) {
        url = util.appendParamToURL(url, 'setId', setId);
    }

    return Promise.resolve(
        $.ajax({
            type: 'POST',
            url: url,
            data: $form.serialize()
        })
    );
};

/**
 * @description Parses the add-to-cart response and updates minicart
 * @param {Object} response The minicart AJAX response
 * @returns {Array[String]} the splitted response
 */
var handleAddToCartResponse = function (response) {
    let reminderSection = $('.product-reminder-section').find('.cart-limit-error')[0];
    $(reminderSection).addClass('reminder-hidden');
    let options = {};
    let splitted = response.split(util.contentSplitter);

    if (splitted && splitted.length) {
        try {
            options = JSON.parse(splitted[1]);
        } catch (err) {
            // nothing to do, default value is {}
        }
        minicart.update(splitted[0], options);
    }
    return splitted;
};

/**
 * @description Handles insuccessful add to cart responses
 * @param {Object} response The minicart AJAX response
 * @returns {void}
 */
var handleAddToCartResponseError = function () {
    let reminderSection = $('.product-reminder-section').find('.cart-limit-error')[0];
    $(reminderSection).removeClass('reminder-hidden');
    return;
};

/**
 * @description Handler to handle the add to cart event
 */
var addToCart = function (e) {
    const $this = $(this);
    var membersOnlyFlyin = require('../../flyins/membersonlyflyin');
    var $form = $this.closest('form');
    e.preventDefault();

    let btn = $('#add-to-cart');

    if (btn.hasClass('disabled-btn') && btn.attr('aria-disabled') === 'true') {
        return;
    }

    if (
        $this.hasClass('member-shop') ||
        $this.hasClass('pre-order-button') ||
        $this.hasClass('member-exclusives') ||
        $this.hasClass('sign-in-to-buy')
    ) {
        membersOnlyFlyin.init(e.target);
        return;
    }

    if ($('.btn-bopis').length > 0) {
        var checkBopisStatus = {allow: true};
        $('body').trigger('verifyShippingOptions', checkBopisStatus);
        if (!checkBopisStatus.allow) {
            return;
        }
    }

    addItemToCart($form).then(
        function (response) {
            if (!response.success && response.error) {
                return handleAddToCartResponseError(response);
            }
            var $uuid = $form.find('input[name="uuid"]');
            var splitted = handleAddToCartResponse(response);
            if ($(response).filter('.sign-in-to-buy-error-message').length > 0) {
                membersOnlyFlyin.init(e.target);
                return;
            }

            if ($uuid.length && $uuid.val().length) {
                page.refresh();
            } else {
                if (!$form.hasClass('quickShopForm')) {
                    cartoverlay.show(splitted[2]);

                    if ($('.product-set-item').length) {
                        dytracking.trackAddToCartProductSetItem($form);
                    } else {
                        dytracking.trackAddToCart();
                        fitPredictor.trackAddToCart();
                    }
                } else {
                    $('.ocd-close').trigger('click');
                }
            }
            const price = $('#pdpMain').find('.component.price')[0].dataset.price;
            optiTracking.pushEventToOptimizely('ADD_TO_CART', price);
            optiExperiment.trackEvent('addToCart');
        }.bind(this)
    );
};

/**
 * @description Handler to handle the add all items to cart event
 */
var addAllToCart = function (e) {
    var productForms = $('.product-set-item form.pdpForm').toArray();
    var lastForm = productForms[productForms.length - 1];
    var setId = $('.product-detail.product-set-detail').data('setId');
    let setProductsIds = productForms
        .map(form => {
            return $(form).find('input[name="pid"]').val();
        })
        .join(',');
    let setProductsQtys = productForms
        .map(form => {
            return $(form).find('input[name="Quantity"]').val();
        })
        .join(',');
    e.preventDefault();
    productForms.pop();
    progress.show($('#pdpMain'));
    Promise.all(productForms.map(addItemToCart))
        .then(function () {
            addItemToCart(lastForm, setId)
                .then(function (response) {
                    // show the final response only, which would include all the other items
                    var splitted = handleAddToCartResponse(response);
                    progress.hide();
                    cartoverlay.show(splitted[2]);

                    var $cartoverlay = $('.add-to-cart-fly-in');
                    var $setPriceElement = $('.product-set-price');
                    if ($cartoverlay.length > 0 && $setPriceElement.length > 0) {
                        var priceText = $setPriceElement.text();
                        var $cartPrice = $cartoverlay.find('.product-price-cartoverlay .price-standard');

                        if (priceText != '' && $cartPrice.length > 0) {
                            $cartPrice.html(priceText);
                        }
                    }

                    // track set 'add to cart' event
                    let getTrackingDataUrl = $('.product-detail.product-set-detail').data('get-tracking-url');
                    gtmTracking.trackProductSetAddToCart(setProductsQtys, setProductsIds, getTrackingDataUrl);
                    optiExperiment.trackEvent('addToCart');
                })
                .catch(function () {
                    progress.hide();
                });
        })
        .catch(function () {
            progress.hide();
        });
};

var addProductAfterLogin = function (pid) {
    $.ajax({
        type: 'POST',
        url: util.ajaxUrl(Urls.addProduct),
        data: 'Quantity=1&cartAction=update&format=ajax&pid=' + pid,
        success: function (response) {
            var splitted = handleAddToCartResponse(response);
            if (typeof splitted[2] !== 'undefined') {
                cartoverlay.show(splitted[2]);
            }
        }
    });
};

/**
 * @description Updates add to cart button state on initial render and on each variation switch
 * @param {Boolean} isPDPUpdated Determines whether PDP was updated or not
 * @param {Boolean} isHintUpdateNeeded Determines whether the purchase hint needs to be updated or not
 */
const updateAddToCartButtonState = (isPDPUpdated, isHintUpdateNeeded = false) => {
    const addToCartButton = $('#add-to-cart');
    const addToCartStickyButton = $('#add-to-cart-sticky');
    const addToCartContainer = $('#addToCartContainer');
    const addToCartStickyContainer = $('.add-to-cart-sticky');
    const isProductMemberOnly = addToCartContainer.data('is-product-members-only');
    const enablePreOrder = addToCartContainer.data('is-enable-pre-order');
    const isAvailableForPreOrder = addToCartContainer.data('is-available-for-pre-order');
    const hasPreOrderVariations = addToCartContainer.data('has-pre-order-variations');
    const isMemberExclusivesProduct = addToCartContainer.data('is-member-exclusives-product');
    const hasMemberExclusivesVariations = addToCartContainer.data('has-member-exclusives-variations');
    const signInToBuyTitle = addToCartContainer.data('sign-in-to-buy-button-title');
    const isCustomerAuthenticateedInitial = $('#customerDataContainer').data('is-customer-authenticated');
    const availabilityMessageWrapper = $('.js-availability-message-wrapper');
    let isCustomerAuthenticateedUpdated =
        availabilityMessageWrapper.length > 0
            ? availabilityMessageWrapper.data('is-customer-authenticated')
            : isCustomerAuthenticateedInitial;
    let isCustomerAuthenticated;
    let buttonTitle = addToCartContainer.data('global-add-to-cart-button-title');
    let buttonClass = '';
    let buttonsContainerClass = '';

    if (isPDPUpdated) {
        isCustomerAuthenticated = isCustomerAuthenticateedUpdated;
    } else {
        // Reads data from Header uncached remote include on initial PDP render
        isCustomerAuthenticated = isCustomerAuthenticateedInitial;
    }

    if (isPDPUpdated && isCustomerAuthenticateedInitial !== isCustomerAuthenticateedUpdated) {
        const currentUrl = location.href;
        // reloads page in case the customer state was changed
        location.href = currentUrl;
    }

    if (isProductMemberOnly && !isCustomerAuthenticated) {
        buttonTitle = signInToBuyTitle;
        buttonClass += ' member-shop button-custom-red-bordeaux solid';
    }

    if (isAvailableForPreOrder || hasPreOrderVariations) {
        buttonsContainerClass += ' pre-order';
    }

    if (isAvailableForPreOrder || hasPreOrderVariations) {
        if (!isCustomerAuthenticated) {
            buttonTitle = addToCartContainer.data('sign-in-to-preorder-button-title');
            buttonClass += ' pre-order-button';
        } else {
            if (enablePreOrder) {
                buttonTitle = addToCartContainer.data('pre-order-button-title');
            }
        }
    }

    if (isMemberExclusivesProduct || hasMemberExclusivesVariations) {
        if (!isCustomerAuthenticated) {
            buttonTitle = signInToBuyTitle;
            buttonClass += ' member-exclusives sign-in-to-buy';
        }
        buttonsContainerClass += ' member-exclusives';
    }

    addToCartContainer.addClass(buttonsContainerClass);
    addToCartStickyContainer.addClass(buttonsContainerClass);
    addToCartButton.addClass(buttonClass).text(buttonTitle);
    addToCartStickyButton.addClass(buttonClass).text(buttonTitle);

    if (isHintUpdateNeeded) {
        const membersOnlyHint = $('.members-only-product-hint');
        const hintContainer = $('#hintContainer');

        membersOnlyHint.toggleClass('customer-logged-in', isCustomerAuthenticated);
        hintContainer.toggleClass('customer-logged-in', isCustomerAuthenticated);
    }
};

/**
 * @function
 * @description Binds the click event to a given target for the add-to-cart handling
 */
module.exports = function (skipVariationValidation) {
    var $productDetail = $('.product-detail');
    if (!skipVariationValidation) {
        variationValidation.init();
    }

    $('.add-to-cart:not(#add-all-to-cart)').each(function () {
        $(this).attr('title', $(this).closest('form').find('.availability-msg').text().trim());
    });
    $productDetail.on('click', '.add-to-cart:not(#add-all-to-cart)', addToCart);
    $productDetail.on('click', '#add-all-to-cart:not(.add-to-cart-disabled)', addAllToCart);
};

module.exports.addProductAfterLogin = addProductAfterLogin;
module.exports.addItemToCart = addItemToCart;
module.exports.handleAddToCartResponseError = handleAddToCartResponseError;
module.exports.updateAddToCartButtonState = updateAddToCartButtonState;
